"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownIndicator = exports.DropdownIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowDownIcon_1 = __importDefault(require("@8x8/oxygen-icon/novo/ArrowDownIcon"));
const getIndicatorColor = (props) => {
    const { isDisabled, theme } = props;
    if (isDisabled) {
        return theme.indicatorColorDisabled;
    }
    return theme.indicatorColor;
};
exports.DropdownIcon = (0, styled_components_1.default)(ArrowDownIcon_1.default).attrs(props => ({
    color: getIndicatorColor(props),
})) `
  ${({ left, theme }) => left
    ? `margin-right: ${theme.indicatorLeftMargin};`
    : `margin-left: ${theme.indicatorLeftMargin};`};
`;
exports.DropdownIndicator = styled_components_1.default.span `
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 8px solid ${getIndicatorColor};
  ${({ left, theme }) => left
    ? `margin: 0 calc(5px + ${theme.indicatorLeftMargin}) 0 5px;`
    : `margin: 0 5px 0 calc(5px + ${theme.indicatorLeftMargin});`};
  transform: scale(${({ theme }) => theme.indicatorScale});
`;
exports.default = exports.DropdownIndicator;
